<template>
  <div>
   
    <template  v-if="!editModus && !kombox.id" class="media">
      <div class="media-body media-right text-right">
        <button 
          title="Neuer Eintrag"
          type="button" class="btn btn-sm btn-primary" 
          @click="editModus = true"><span class="glyphicon glyphicon-plus"></span>
        </button>
      </div>
    </template >


   
    <template v-if="!editModus && kombox.id">
      <div  class="media">

        <div @dblclick="editModus = true" class="media-body">
          <div class="media">
            <div class="media-left media-middle" :title="KomboxConf.TYPES[kombox.type].SYMBOL.TITLE">
                <span class="glyphicon" v-bind:class="[KomboxConf.TYPES[kombox.type].SYMBOL.CLASS, KomboxConf.ACLS[kombox.acl].SYMBOL.CLASS]"></span>
            </div>

            <div class="media-body cc-kombox-body  media-middle" >
                <strong v-if="kombox.acl == 3" :title="kombox.content">*******</strong>
                <strong v-else>{{kombox.content}}</strong>
              
                <small>{{kombox.description}}</small>
            </div>
          </div>
        </div>    

        <div class="media-right text-right media-middle">
            <button type="button"
                    class="btn btn-xs btn-primary"
                    v-on:click="editModus = true">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
            </button>

           <button v-show="true" 
                    type="button" class="btn btn-xs btn-default" 
                    v-bind:class="{'btn-success': shippingAktive}" 
                    v-on:click="onClickShipping">
                    <span class="glyphicon glyphicon-send"></span>
            </button>
        </div>
    
      </div>
    </template>

    <cc-kombox-form
       v-if="editModus"
      :kombox="kombox"
     
      @cancel="cancel"
      @remove="remove"
      @save="save">
      <!---<h3 slot="header">custom header</h3>-->
    </cc-kombox-form>

  </div>
</template>



<script>

import KomboxCommon from './common/kombox.common'
import KomboxForm from './KomboxForm.vue'

export default {
  
  extends: KomboxCommon,
  
  components: {
    'cc-kombox-form': KomboxForm,
  },
  

  
  data () {
    return {
      shippingAktive: false,
    }
  },
  
  created: function () {
    // erstmal ein, außer die Nummer ist privat
    if(this.kombox.acl != 3){
      this.emitShipping(true, this.kombox);
    }
  },
  
  
  methods: {
    
    // Overridden 
    onInsert: function (kombox) {
      if(this.kombox.acl != 3){
        this.emitShipping(true, kombox);
      }
      this.$emit('insert', kombox);
    },
  
    // Overridden 
    onUpdate: function (kombox) {
      this.$emit('update', kombox);
    },
  
    // Overridden 
    onCancel: function (kombox) {
      //this.$emit('cancel', kombox);
    },
  
    // Overridden 
    onRemove: function (kombox) {
      this.emitShipping(false, kombox);
      this.$emit('remove', kombox);
    },

    onClickShipping: function () {
      this.emitShipping(!this.shippingAktive, this.kombox);
    },
    
    emitShipping: function (shippingState, kombox) {
      if(this.shippingAktive != shippingState){
        this.shippingAktive = shippingState;
        if(shippingState){
          this.$emit('add-shipping', kombox);
        }else{
          this.$emit('remove-shipping', kombox);
        }
      }
    },

    
  }
  
}
</script>



<style scoped>

  small{
    color: gray;
  }
  
.acl-public{
    color: #00b400;
  }
  
  .acl-intern{
    color: #dacd00;
  }

  .acl-privat{
    color: #be0000;
  }

  .btn{
    padding: 4px 10px;
  }
  
  .cc-btn-menue{
    padding-left: 10px;  
    padding-right: 0px;  
  }
  
  .media-right{
    min-width: 100px;
  }

  .media-left{
    padding-left: 15px;
  }
  
  .cc-kombox-typ{
    padding-bottom: 30px;
  }
  
  .cc-kombox-body{
    border-left: 0px solid red;
    padding-left: 8px;
    line-height: 1.1em;
    min-width: 120px;
  }
  
.media-left .glyphicon {
    padding-right: 0px;
    font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// KomboxUserCaller.vue?01d456d5